<template>
<div>
    <CCol sm="12">
        <CCard>
            <CCardBody class="d-flex flex-column">
                <div class="d-flex mb-2 justify-content-end align-items-start">
                    <!-- Title -->
                    <p class="flex-grow-1">{{ $t('gallery') }}</p>
                    <!-- Language dropdown -->
                    <LanguageDropdown v-model="currentLanguage"></LanguageDropdown>
                </div>
                <!-- Form -->
                <div class="d-flex flex-wrap">
                    <!-- image -->
                    <div role="group" class="form-group col-12">
                        <label class=""> {{ $t('imageMandatory') }}</label>
                        <GalleryPicker class="gallery-picker" v-model="gallery" :ratioWidth="16" :ratioHeight="9" :max="1" v-bind:class="{ 'is-invalid': genericValidator(gallery, attemptedSubmit) === false || errorValidator('Image') === false }"></GalleryPicker>
                    </div>
                </div>
              <!-- Action button + submitting -->  
                <CSpinner v-if="submitting" variant="success" small class="align-self-end"></CSpinner>
                <CButton v-else type="button" class="btn btn-primary align-self-end" @click="submitClicked">{{ $t('acceptChanges') }}</CButton>
                <!-- Loading -->
                <FormLoading v-if="loading"></FormLoading>
            </CCardBody>
        </CCard>
    </CCol>
    <ConfirmationPopUp :confirmationMessage="confirmationMessage" @closeConfirmRequested="onClickConfirmationPopup" v-model="showConfirmationPopup"></ConfirmationPopUp>
</div>
</template>
 
<script>
import { mapState } from 'vuex'
import router from '@/router/index';
import { API_HELPER } from "@/helpers/api.js";
import { CONSTANTS } from '@/helpers/consts';
import { genericValidator, errorValidator } from "@/helpers/utils.js";


import LanguageDropdown from '@/controls/LanguageDropdown.vue'
import ConfirmationPopUp from "@/controls/popups/ConfirmationPopUp.vue";
import GalleryPicker from '@/controls/GalleryPicker.vue'
import FormLoading from '@/controls/FormLoading.vue'

  export default {
        components: { LanguageDropdown, ConfirmationPopUp, GalleryPicker, FormLoading },
    props:{    
        baseGallery:
        {
            type: Object,
            default: null,
        },
        baseName:
        {
            type: String,
            default: null,
        },
        loading:
        {
            type: Boolean,
            default: false,
        },
    },
    data()
    {
        return {
            attemptedSubmit: false,
            currentLanguage: CONSTANTS.supportedLanguages[0],
            gallery: null,
            submitting: false,
            showConfirmationPopup: false,
            confirmationMessage:"",
        }
    },
    mounted: function()
    {
        this.resetGallery();
    },
    computed:
    {
        ...mapState('gallery', ['putGalleryOutput']),
        ...mapState('gallery', ['postGalleryOutput']),
        ...mapState({ 
            alertType: state => state.alert.type,
            alertOutput: state => state.alert.output
        }),
        name: function () {
            return this.baseGallery || this.baseName ? (this.baseGallery ? this.baseGallery.name : this.baseName) : null;
        }
    },
    methods:{
        genericValidator,
        errorValidator,
        resetGallery(){
            if(this.baseGallery)
            {
                this.gallery = {url: API_HELPER.pathJoin([process.env.VUE_APP_URL_ROOT, this.gallery]), path: this.gallery};
            }
        },
        submitClicked(){
            this.attemptedSubmit = true;

            // Emit event
            if(this.gallery)
            {
                this.submitting = true;
                this.$emit('submit-requested', this.gallery);
            }
        },
        onClickConfirmationPopup(value){
            this.showConfirmationPopup = value;     
            router.push({name: "Gallery"});
        },
        onProcessTask: function(val)
        {
            if(val != null)
            {
                if(val)
                {
                    this.showConfirmationPopup = true;
                }

                this.submitting = false;
            }
        }
    },
    watch:
    {
        putGalleryOutput: function(val)
        {
            this.onProcessTask(val);
        },
        postGalleryOutput: function(val)
        {
            this.onProcessTask(val);
        },
        baseGallery: function()
        {
            this.resetGallery();
        },
        alertOutput: function()
        {
            // Show pop up in case it is a string error
            // In case it is an array, it is shown on the field
            if(typeof this.alertOutput === 'string' || this.alertOutput instanceof String)
            {
                alert(this.alertOutput);
            }
        }
    }
  }
</script> 
 
<style scoped>

@media only screen and (max-width: 767px) {
    .main-content {
        flex-direction: column;
    }
}

/deep/.quillWrapper.is-invalid .ql-snow.ql-toolbar,
/deep/.quillWrapper.is-invalid .ql-snow.ql-container
{
    border-color: #e55353;
}
</style> 